// KeynomeManagerDownload.jsx
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


const styles = {
  instructionsContainer: {
    padding: "20px"
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 3
  },
  instructionsTitle: {
    fontWeight: "bold"
  },
  tabs: {
    minHeight: '40px',
    '& .MuiTab-root': {
      minHeight: '40px',
      padding: '6px 16px'
    }
  },
  codeBlock: {
    backgroundColor: "#eee",
    padding: "2px 6px",
    borderRadius: "5px"
  },
  listItem: {
    marginBottom: "8px"
  },
  orderedList: {
    margin: 0,
    paddingLeft: "20px"
  },
  osSpecificInstructions: {
    mb: 1,
    mt: 2
  },
};


function KeynomeManagerDownloadInstructions() {
  return (
    <Box sx={styles.instructionsContainer}>
      <Box sx={styles.headerContainer}>
        <Typography sx={styles.instructionsTitle}>
          Installation Instructions
        </Typography>
      </Box>

      <Box sx={styles.osSpecificInstructions}>

        {/* ========== LINUX INSTRUCTIONS ========== */}
        <div>
          <ol style={styles.orderedList}>
            <li style={styles.listItem}>
              Download the <code style={styles.codeBlock}>pathosight-cli</code> binary for Linux (Ubuntu) and place it somewhere in your filesystem (e.g. in <code style={styles.codeBlock}>~/.pathosight/bin/pathosight-cli</code>).
            </li>
            <li style={styles.listItem}>
              Make sure that this directory is on your <code style={styles.codeBlock}>PATH</code> (i.e. add <code style={styles.codeBlock}>export PATH=$PATH:$HOME/.pathosight/bin</code> to your <code style={styles.codeBlock}>.bashrc</code>)
            </li>
            <li style={styles.listItem}>
              Run <code style={styles.codeBlock}>chmod +x ~/.pathosight/bin/pathosight-cli</code>
            </li>
            <li style={styles.listItem}>
              Confirm your installation with <code style={styles.codeBlock}>pathosight-cli --help</code>
            </li>
            <li style={styles.listItem}>
              Click your initials at the top right of the page {'>'} "Documentation" {'>'} "Upload Sequencing Data - Pathosight CLI" to begin your first upload.
            </li>
          </ol>
        </div>
      </Box>
    </Box>
  );
}

export default KeynomeManagerDownloadInstructions;
